import React from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import PageListTitle from './PageListTitle'
import URL from './URL'
import Icon from './Icon'

const Checks = (props) => {
    const noDescription = useData('checks/no_description')
    console.log({ noDescription })
    const noPermalink = useData('checks/no_permalink')
    const siteNoAuthor = useData('checks/site_no_author')
    const siteNoBackground = useData('checks/site_no_background')
    const siteNoLogo = useData('checks/site_no_logo')
    const siteNoFavicon = useData('checks/site_no_favicon')
    const linkTags = useData('checks/link_tags')
    console.log({ linkTags })
    const loremIpsum = useData('checks/lorem_ipsum')

    return (
        <>
            {(noDescription.isReady && (
                <>
                    {(noDescription.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {noDescription.data.length} published articles with no description
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published articles have a description
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(noDescription.data || []).map((a) => (
                                <tr key={a.id}>
                                    <td>
                                        <small>{a.site_label}</small>
                                        <br />
                                        <PageListTitle {...a} />
                                        <URL url={'/' + a.permalink} />
                                    </td>
                                    <td className="text-right">
                                        <a href={`/article/edit/${a.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published articles with no description" />}
            {(noPermalink.isReady && (
                <>
                    {(noPermalink.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {noPermalink.data.length} published articles with no permalink
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published articles have a permalink
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(noPermalink.data || []).map((a) => (
                                <tr key={a.id}>
                                    <td>
                                        <small>{a.site_label}</small>
                                        <br />
                                        <PageListTitle {...a} />
                                        <URL url={'/' + a.permalink} />
                                    </td>
                                    <td className="text-right">
                                        <a href={`/article/edit/${a.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published articles with no permalink" />}
            {(siteNoAuthor.isReady && (
                <>
                    {(siteNoAuthor.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {siteNoAuthor.data.length} published sites with no author
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published websites have an author
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(siteNoAuthor.data || []).map((s) => (
                                <tr key={s.id}>
                                    <td>
                                        <strong>{s.label}</strong>
                                    </td>
                                    <td className="text-right">
                                        <a href={`/site/edit/${s.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published sites with no author" />}
            {(siteNoBackground.isReady && (
                <>
                    {(siteNoBackground.data.length && (
                        <>
                            <h4 className={'mt-4 text-warning'}>
                                <Icon name="warning" className="mr-2" />
                                {siteNoBackground.data.length} published sites with no image / background
                            </h4>
                        </>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published websites have an image / background
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(siteNoBackground.data || []).map((s) => (
                                <tr key={s.id}>
                                    <td>
                                        <strong>{s.label}</strong>
                                    </td>
                                    <td className="text-right">
                                        <a href={`/site/edit/${s.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published sites with no background" />}
            {(siteNoLogo.isReady && (
                <>
                    {(siteNoLogo.data.length && (
                        <>
                            <h4 className={'mt-4 text-warning'}>
                                <Icon name="warning" className="mr-2" />
                                {siteNoLogo.data.length} published sites with no logo
                            </h4>
                            <p>A logo is required by the JSON-LD publisher &gt; organization object. Providing a logo for a website will improve SEO.</p>
                        </>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published websites have a logo
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(siteNoLogo.data || []).map((s) => (
                                <tr key={s.id}>
                                    <td>
                                        <strong>{s.label}</strong>
                                    </td>
                                    <td className="text-right">
                                        <a href={`/site/edit/${s.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published sites with no logo" />}
            {(siteNoFavicon.isReady && (
                <>
                    {(siteNoFavicon.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {siteNoFavicon.data.length} published sites with no Favicon
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published websites have a Favicon
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(siteNoFavicon.data || []).map((s) => (
                                <tr key={s.id}>
                                    <td>
                                        <strong>{s.label}</strong>
                                    </td>
                                    <td className="text-right">
                                        <a href={`/site/edit/${s.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading published sites with no Favicon" />}
            {(linkTags.isReady && (
                <>
                    {(linkTags.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {linkTags.data.length} published links with an invalid tag
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            All published links are valid
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(linkTags.data || []).map((s, index) => (
                                <tr key={index}>
                                    <td>
                                        <strong>{s.title}</strong>
                                        {s.link_array?.length && (
                                            <>
                                                {' '}
                                                - {s.link_array.length} link{s.link_array.length > 1 ? 's' : ''}
                                            </>
                                        )}
                                        <br />
                                        {s.site_label}
                                    </td>
                                    <td className="text-right">
                                        <a href={`/article/edit/${s.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text="Loading links with invalid tags" />}
            {(loremIpsum.isReady && (
                <>
                    {(loremIpsum.data.length && (
                        <h4 className={'mt-4 text-warning'}>
                            <Icon name="warning" className="mr-2" />
                            {loremIpsum.data.length} published articles with "Lorem ipsum"
                        </h4>
                    )) || (
                        <h4 className="mt-4 text-success">
                            <Icon name="check" className="mr-2" />
                            No published article contains "Lorem ipsum"
                        </h4>
                    )}
                    <table className="table">
                        <tbody>
                            {(loremIpsum.data || []).map((a, index) => (
                                <tr key={index}>
                                    <td>
                                        <strong>{a.title}</strong>
                                    </td>
                                    <td className="text-right">
                                        <a href={`/article/edit/${a.id}`} className="btn btn-primary btn-xs">
                                            FIX NOW
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )) || <Loading text='Loading articles with "Lorem ipsum"' />}
        </>
    )
}

export default Checks
